const EMPTY_PAYLOAD = {
  id: '',
  body: [],
};

export { EMPTY_PAYLOAD };
